export default __webpack_public_path__ + "static/media/Kaeya1.d4f0be97.mp3";